import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import * as log from '../util/log';
import { PrivateShopConfig, ShopConfigV2 } from '../types/shopConfig/shopConfigV2';
import {
  aceandjigShopConfig,
  allegrajamesShopConfig,
  allwearShopConfig,
  alpakagearConfig,
  altarpdxShopConfig,
  alysoneastmanShopConfig,
  americanleathercoShopConfig,
  amodenimShopConfig,
  andarShopConfig,
  anianShopConfig,
  asrvShopConfig,
  astraldesignsShopConfig,
  astrthelabelShopConfig,
  ayblShopConfig,
  baabukShopConfig,
  baboontothemoonShopConfig,
  bandierShopConfig,
  beddysShopConfig,
  betterlifebagsShopConfig,
  billyreidShopConfig,
  birdygreyShopConfig,
  blackmilkclothingShopConfig,
  blackmilkclothingUsShopConfig,
  blueillusionShopConfig,
  bohemianmamaShopConfig,
  boyishShopConfig,
  briarbabyShopConfig,
  brooklynclothShopConfig,
  bryrShopConfig,
  burjushoesShopConfig,
  cadenlaneShopConfig,
  cafeducyclisteDeShopConfig,
  cafeducyclisteFrShopConfig,
  cafeducyclisteShopConfig,
  cafeducyclisteUsShopConfig,
  callahanShopConfig,
  carilohaShopConfig,
  charlottestoneShopConfig,
  cinnamonbabyauShopConfig,
  cleobellaShopConfig,
  coclicoShopConfig,
  costumeboxShopConfig,
  cotopaxiShopConfig,
  cozyearthShopConfig,
  creocardsShopConfig,
  crosbybymollieburchShopConfig,
  crownforeverlaShopConfig,
  curatorsfShopConfig,
  cutsShopConfig,
  danielPatrickShopConfig,
  dixxonShopConfig,
  dl1961ShopConfig,
  doenShopConfig,
  dollskillShopConfig,
  dreamlandbabycoShopConfig,
  eksterShopConfig,
  electricandroseShopConfig,
  electricyogaShopConfig,
  elevatedfaithShopConfig,
  elfinlosangelesShopConfig,
  elizabethsuzannShopConfig,
  encircledCaShopConfig,
  encircledUsShopConfig,
  epoqueevolutionShopConfig,
  ergopouchShopConfig,
  esemblybabyShopConfig,
  ettitudeShopConfig,
  exoticathleticaShopConfig,
  finnandemmaShopConfig,
  firebirdShopConfig,
  forloveandlemonsShopConfig,
  fortressShopConfig,
  freedomravewearAuShopConfig,
  freedomravewearCaShopConfig,
  freedomravewearEuShopConfig,
  freedomravewearShopConfig,
  freedomravewearUkShopConfig,
  fumbalinasShopConfig,
  galialahavShopConfig,
  gerganaivanovaShopConfig,
  girlcrushShopConfig,
  girlfriendShopConfig,
  goldieandaceShopConfig,
  goldieteesShopConfig,
  goodlifeShopConfig,
  gravelandgoldShopConfig,
  grayersShopConfig,
  hammittShopConfig,
  hatleyShopConfig,
  heathCeramicsShopConfig,
  helmShopConfig,
  henkaaShopConfig,
  hernestprojectShopConfig,
  holdenouterwearSizesShopConfig,
  hopeandplumShopConfig,
  howlerbrosShopConfig,
  hudsonjeansShopConfig,
  huxbabyShopConfig,
  hyergoodsShopConfig,
  iksplorShopConfig,
  industryofallnationsShopConfig,
  ingridandisabelShopConfig,
  inheritcoShopConfig,
  ironandresinShopConfig,
  itsmillaShopConfig,
  jamesstreetcoShopConfig,
  jennylemonsShopConfig,
  jillianboustredShopConfig,
  joahloveShopConfig,
  joanieShopConfig,
  joesjeansShopConfig,
  johnandmickieShopConfig,
  jordancraigShopConfig,
  joyfolieShopConfig,
  jujubeShopConfig,
  jungmavenShopConfig,
  karinadressesShopConfig,
  katehewkoShopConfig,
  kavuShopConfig,
  kickeepantsShopConfig,
  kirrinfinchShopConfig,
  kitsbowShopConfig,
  kittenyShopConfig,
  koralShopConfig,
  kpopexchangeShopConfig,
  kurufootwearShopConfig,
  kyrgiesShopConfig,
  lafemmeaperoShopConfig,
  lagenceShopConfig,
  lane201ShopConfig,
  laudethelabelShopConfig,
  leathermanShopConfig,
  lilcactusShopConfig,
  littleandlivelyShopConfig,
  livetheprocessShopConfig,
  livieandlucaShopConfig,
  livsnShopConfig,
  lornajaneShopConfig,
  loveandgrowclothingShopConfig,
  lovedbabyShopConfig,
  loveveryShopConfig,
  lunapacaShopConfig,
  lykkewullfShopConfig,
  maajiShopConfig,
  maboclothierShopConfig,
  mainstreetexchangeapparelShopConfig,
  mansurgavrielShopConfig,
  melinShopConfig,
  miakodaShopConfig,
  mignonnegaviganShopConfig,
  mikimietteShopConfig,
  minimiocheShopConfig,
  ministryofsupplyShopConfig,
  minnowShopConfig,
  moderncitizenShopConfig,
  mondettacanadaShopConfig,
  mondettausaShopConfig,
  moskomotoShopConfig,
  mpatmosShopConfig,
  musethreadsShopConfig,
  mylesShopConfig,
  mymummadeitShopConfig,
  naadamShopConfig,
  namaiShopConfig,
  nationShopConfig,
  nettlestudiosShopConfig,
  neunomadsShopConfig,
  noguShopConfig,
  nooworksShopConfig,
  nuiorganicsShopConfig,
  ohpollyShopConfig,
  onlylittleonceShopConfig,
  opheliaandindigoShopConfig,
  oschaslingsUkShopConfig,
  oschaslingsUsShopConfig,
  osoandmeShopConfig,
  outnaboutShopConfig,
  pactShopConfig,
  paktShopConfig,
  parkerclayShopConfig,
  parksprojectShopConfig,
  peachyDogsShopConfig,
  pfflyersShopConfig,
  pinupgirlclothingShopConfig,
  pistollakeShopConfig,
  plaeShopConfig,
  polejunkieShopConfig,
  pontoShopConfig,
  poplinenShopConfig,
  portlandleatherShopConfig,
  princesspollyShopConfig,
  prismboutiqueShopConfig,
  proudpoppyclothingShopConfig,
  purebabyShopConfig,
  quinceandcoShopConfig,
  quincymaeShopConfig,
  rachelantonoffShopConfig,
  ranchroadShopConfig,
  ratboiShopConfig,
  raveivalShopConfig,
  redoppleShopConfig,
  relightCommunityMarketplaceShopConfig,
  relovedShopConfig,
  representEuShopConfig,
  representShopConfig,
  representUsShopConfig,
  rixolondonShopConfig,
  robertgrahamShopConfig,
  rollasjeansAuShopConfig,
  rollasjeansUsShopConfig,
  romanandrileyShopConfig,
  rooleeShopConfig,
  roughandtumbleShopConfig,
  ryleeandcruShopConfig,
  saguaroshowpadsShopConfig,
  sakurabloomShopConfig,
  sanctuaryclothingShopConfig,
  sarahwellsbagsShopConfig,
  saylorShopConfig,
  schutzShopConfig,
  seaestasurfShopConfig,
  seniqShopConfig,
  senitaathleticsShopConfig,
  sforceShopConfig,
  shefitShopConfig,
  shopduerCAShopConfig,
  shopduerUSShopConfig,
  shopdyiShopConfig,
  shopeitherorShopConfig,
  shopfavoritedaughterShopConfig,
  shortyloveShopConfig,
  shrimpandgritskidsShopConfig,
  shrimpsShopConfig,
  sijoShopConfig,
  simonsShopConfig,
  skhoopShopConfig,
  southernTatersShopConfig,
  southerntideShopConfig,
  sozyShopConfig,
  spellShopConfig,
  spellusaShopConfig,
  standardandstrangeShopConfig,
  statebagsShopConfig,
  statethelabelShopConfig,
  superxShopConfig,
  surlacoteShopConfig,
  swoverallsShopConfig,
  tadashishojiShopConfig,
  tallsizeCaShopConfig,
  tallsizeShopConfig,
  talulahShopConfig,
  teacollectionShopConfig,
  tecovasShopConfig,
  teddyblakeShopConfig,
  teekiboutiqueShopConfig,
  tenable6ShopConfig,
  tentreeCaShopConfig,
  tentreeShopConfig,
  texasstandardShopConfig,
  theandibrandShopConfig,
  thebeaufortbonnetcompanyShopConfig,
  thebeeandthefoxShopConfig,
  theheygangShopConfig,
  thehippieshakeUkShopConfig,
  thehippieshakeUsShopConfig,
  thelullabyclubShopConfig,
  thenutrShopConfig,
  thesakShopConfig,
  theslowwardrobeUkShopConfig,
  theslowwardrobeUsShopConfig,
  timininousShopConfig,
  tortugabackpacksShopConfig,
  tradlandsShopConfig,
  treetfontsShopConfig,
  treetonShopConfig,
  tripleaughtdesignShopConfig,
  tuesdayofcaliforniaShopConfig,
  ukjeShopConfig,
  unhideShopConfig,
  unifShopConfig,
  unionbayShopConfig,
  unitedbyblueShopConfig,
  urbancredShopConfig,
  velvetyShopConfig,
  vettaShopConfig,
  viscataShopConfig,
  vitaeapparelShopConfig,
  vitalydesignShopConfig,
  vivobarefootcaShopConfig,
  vplShopConfig,
  waterlustShopConfig,
  wayreShopConfig,
  weisswatchcompanyShopConfig,
  westernandcoShopConfig,
  whimsyandrowShopConfig,
  whyandwhaleShopConfig,
  wildryeShopConfig,
  wolvenShopConfig,
  woodleyloweShopConfig,
  wornhubShopConfig,
  wrayShopConfig,
  youerShopConfig,
  ziabirdShopConfig,
  zulilyShopConfig,
} from './shops';
import { getCategoryFilterConfig } from './filters/styles';
import { ShopConfigResponse } from '../types/contentful/shopConfig';
import { FilterId } from '../types/filters/filters';
import { fallbackDefaultStyles, generateDefaultShopStyles } from '../util/colorPalettes';
import { Feature, isFeatureEnabled } from '../util/featureFlags';

type PrivateShopConfigs = {
  [treetId: string]: PrivateShopConfig;
};

const privateShopConfigs: PrivateShopConfigs = {
  aceandjig: aceandjigShopConfig,
  allegrajames: allegrajamesShopConfig,
  alpakagear: alpakagearConfig,
  allwear: allwearShopConfig,
  altarpdx: altarpdxShopConfig,
  alysoneastman: alysoneastmanShopConfig,
  anian: anianShopConfig,
  americanleatherco: americanleathercoShopConfig,
  amodenim: amodenimShopConfig,
  asrv: asrvShopConfig,
  astraldesigns: astraldesignsShopConfig,
  astrthelabel: astrthelabelShopConfig,
  aybl: ayblShopConfig,
  baabuk: baabukShopConfig,
  baboontothemoon: baboontothemoonShopConfig,
  bandier: bandierShopConfig,
  beddys: beddysShopConfig,
  proudpoppyclothing: proudpoppyclothingShopConfig,
  cadenlane: cadenlaneShopConfig,
  billyreid: billyreidShopConfig,
  birdygrey: birdygreyShopConfig,
  betterlifebags: betterlifebagsShopConfig,
  bohemianmama: bohemianmamaShopConfig,
  boyish: boyishShopConfig,
  briarbaby: briarbabyShopConfig,
  brooklyncloth: brooklynclothShopConfig,
  bryr: bryrShopConfig,
  burjushoes: burjushoesShopConfig,
  callahan: callahanShopConfig,
  cariloha: carilohaShopConfig,
  cafeducycliste: cafeducyclisteShopConfig,
  'cafeducycliste-fr': cafeducyclisteFrShopConfig,
  'cafeducycliste-us': cafeducyclisteUsShopConfig,
  'cafeducycliste-de': cafeducyclisteDeShopConfig,
  'charlotte-stone': charlottestoneShopConfig,
  cinnamonbabyau: cinnamonbabyauShopConfig,
  cleobella: cleobellaShopConfig,
  coclico: coclicoShopConfig,
  costumebox: costumeboxShopConfig,
  cotopaxi: cotopaxiShopConfig,
  cozyearth: cozyearthShopConfig,
  creocards: creocardsShopConfig,
  crosbybymollieburch: crosbybymollieburchShopConfig,
  crownforeverla: crownforeverlaShopConfig,
  curatorsf: curatorsfShopConfig,
  cuts: cutsShopConfig,
  'daniel-patrick': danielPatrickShopConfig,
  dixxon: dixxonShopConfig,
  dl1961: dl1961ShopConfig,
  doen: doenShopConfig,
  dollskill: dollskillShopConfig,
  dreamlandbabyco: dreamlandbabycoShopConfig,
  ekster: eksterShopConfig,
  elevatedfaith: elevatedfaithShopConfig,
  electricandrose: electricandroseShopConfig,
  electricyoga: electricyogaShopConfig,
  elfinlosangeles: elfinlosangelesShopConfig,
  elizabethsuzann: elizabethsuzannShopConfig,
  'encircled-ca': encircledCaShopConfig,
  'encircled-us': encircledUsShopConfig,
  'epoque-evolution': epoqueevolutionShopConfig,
  ergopouch: ergopouchShopConfig,
  'ergopouch-us': ergopouchShopConfig,
  esemblybaby: esemblybabyShopConfig,
  ettitude: ettitudeShopConfig,
  exoticathletica: exoticathleticaShopConfig,
  finnandemma: finnandemmaShopConfig,
  fumbalinas: fumbalinasShopConfig,
  sanctuaryclothing: sanctuaryclothingShopConfig,
  firebird: firebirdShopConfig,
  forloveandlemons: forloveandlemonsShopConfig,
  fortress: fortressShopConfig,
  freedomravewear: freedomravewearShopConfig,
  'freedomravewear-au': freedomravewearAuShopConfig,
  'freedomravewear-ca': freedomravewearCaShopConfig,
  'freedomravewear-eu': freedomravewearEuShopConfig,
  'freedomravewear-uk': freedomravewearUkShopConfig,
  galialahav: galialahavShopConfig,
  gerganaivanova: gerganaivanovaShopConfig,
  girlcrush: girlcrushShopConfig,
  girlfriend: girlfriendShopConfig,
  goldieandace: goldieandaceShopConfig,
  goldietees: goldieteesShopConfig,
  goodlife: goodlifeShopConfig,
  gravelandgold: gravelandgoldShopConfig,
  grayers: grayersShopConfig,
  hammitt: hammittShopConfig,
  'hatley-us': hatleyShopConfig,
  'hatley-ca': hatleyShopConfig,
  helm: helmShopConfig,
  henkaa: henkaaShopConfig,
  hernestproject: hernestprojectShopConfig,
  holdenouterwear: holdenouterwearSizesShopConfig,
  hopeandplum: hopeandplumShopConfig,
  howlerbros: howlerbrosShopConfig,
  hudsonjeans: hudsonjeansShopConfig,
  huxbaby: huxbabyShopConfig,
  hyergoods: hyergoodsShopConfig,
  iksplor: iksplorShopConfig,
  industryofallnations: industryofallnationsShopConfig,
  ingridandisabel: ingridandisabelShopConfig,
  inheritco: inheritcoShopConfig,
  ironandresin: ironandresinShopConfig,
  itsmilla: itsmillaShopConfig,
  jamesstreetco: jamesstreetcoShopConfig,
  jennylemons: jennylemonsShopConfig,
  jillianboustred: jillianboustredShopConfig,
  joahlove: joahloveShopConfig,
  joanie: joanieShopConfig,
  joesjeans: joesjeansShopConfig,
  johnandmickie: johnandmickieShopConfig,
  jordancraig: jordancraigShopConfig,
  joyfolie: joyfolieShopConfig,
  jujube: jujubeShopConfig,
  jungmaven: jungmavenShopConfig,
  karinadresses: karinadressesShopConfig,
  'katehewko-ca': katehewkoShopConfig,
  'katehewko-us': katehewkoShopConfig,
  kavu: kavuShopConfig,
  kickeepants: kickeepantsShopConfig,
  kirrinfinch: kirrinfinchShopConfig,
  kitsbow: kitsbowShopConfig,
  kitteny: kittenyShopConfig,
  koral: koralShopConfig,
  kpopexchange: kpopexchangeShopConfig,
  kurufootwear: kurufootwearShopConfig,
  kyrgies: kyrgiesShopConfig,
  lafemmeapero: lafemmeaperoShopConfig,
  lagence: lagenceShopConfig,
  lane201: lane201ShopConfig,
  leatherman: leathermanShopConfig,
  laudethelabel: laudethelabelShopConfig,
  lilcactus: lilcactusShopConfig,
  littleandlively: littleandlivelyShopConfig,
  livetheprocess: livetheprocessShopConfig,
  livieandluca: livieandlucaShopConfig,
  livsn: livsnShopConfig,
  lornajane: lornajaneShopConfig,
  loveandgrowclothing: loveandgrowclothingShopConfig,
  lovedbaby: lovedbabyShopConfig,
  lovevery: loveveryShopConfig,
  lunapaca: lunapacaShopConfig,
  lykkewullf: lykkewullfShopConfig,
  marketplace: cutsShopConfig,
  maaji: maajiShopConfig,
  mansurgavriel: mansurgavrielShopConfig,
  maboclothier: maboclothierShopConfig,
  mainstreetexchangeapparel: mainstreetexchangeapparelShopConfig,
  melin: melinShopConfig,
  miakoda: miakodaShopConfig,
  mignonnegavigan: mignonnegaviganShopConfig,
  mikimiette: mikimietteShopConfig,
  minimioche: minimiocheShopConfig,
  ministryofsupply: ministryofsupplyShopConfig,
  minnow: minnowShopConfig,
  moderncitizen: moderncitizenShopConfig,
  moskomoto: moskomotoShopConfig,
  'mondetta-canada': mondettacanadaShopConfig,
  'mondetta-usa': mondettausaShopConfig,
  mpatmos: mpatmosShopConfig,
  musethreads: musethreadsShopConfig,
  'mymum-madeit': mymummadeitShopConfig,
  myles: mylesShopConfig,
  naadam: naadamShopConfig,
  namai: namaiShopConfig,
  nation: nationShopConfig,
  nettlestudios: nettlestudiosShopConfig,
  neunomads: neunomadsShopConfig,
  nooworks: nooworksShopConfig,
  nogu: noguShopConfig,
  nuiorganics: nuiorganicsShopConfig,
  ohpolly: ohpollyShopConfig,
  onlylittleonce: onlylittleonceShopConfig,
  'oschaslings-uk': oschaslingsUkShopConfig,
  'oschaslings-us': oschaslingsUsShopConfig,
  osoandme: osoandmeShopConfig,
  opheliaandindigo: opheliaandindigoShopConfig,
  outnabout: outnaboutShopConfig,
  pact: pactShopConfig,
  pakt: paktShopConfig,
  parksproject: parksprojectShopConfig,
  parkerclay: parkerclayShopConfig,
  peachydogs: peachyDogsShopConfig,
  pfflyers: pfflyersShopConfig,
  pinupgirlclothing: pinupgirlclothingShopConfig,
  pistollake: pistollakeShopConfig,
  plae: plaeShopConfig,
  polejunkie: polejunkieShopConfig,
  ponto: pontoShopConfig,
  poplinen: poplinenShopConfig,
  portlandleather: portlandleatherShopConfig,
  princesspolly: princesspollyShopConfig,
  prismboutique: prismboutiqueShopConfig,
  purebaby: purebabyShopConfig,
  quinceandco: quinceandcoShopConfig,
  quincymae: quincymaeShopConfig,
  rachelantonoff: rachelantonoffShopConfig,
  ranchroad: ranchroadShopConfig,
  ratboi: ratboiShopConfig,
  raveival: raveivalShopConfig,
  redopple: redoppleShopConfig,
  relightcommunitymarketplace: relightCommunityMarketplaceShopConfig,
  reloved: relovedShopConfig,
  represent: representShopConfig,
  'represent-eu': representEuShopConfig,
  'represent-us': representUsShopConfig,
  rixolondon: rixolondonShopConfig,
  robertgraham: robertgrahamShopConfig,
  'rollasjeans-au': rollasjeansAuShopConfig,
  'rollasjeans-us': rollasjeansUsShopConfig,
  romanandriley: romanandrileyShopConfig,
  roolee: rooleeShopConfig,
  roughandtumble: roughandtumbleShopConfig,
  ryleeandcru: ryleeandcruShopConfig,
  saguaroshowpads: saguaroshowpadsShopConfig,
  sakurabloom: sakurabloomShopConfig,
  sarahwellsbags: sarahwellsbagsShopConfig,
  saylor: saylorShopConfig,
  schutz: schutzShopConfig,
  seaestasurf: seaestasurfShopConfig,
  seniq: seniqShopConfig,
  senitaathletics: senitaathleticsShopConfig,
  sforce: sforceShopConfig,
  shefit: shefitShopConfig,
  shopdyi: shopdyiShopConfig,
  shopeitheror: shopeitherorShopConfig,
  shopfavoritedaughter: shopfavoritedaughterShopConfig,
  shortylove: shortyloveShopConfig,
  shrimpandgritskids: shrimpandgritskidsShopConfig,
  shrimps: shrimpsShopConfig,
  'shopduer-ca': shopduerCAShopConfig,
  'shopduer-us': shopduerUSShopConfig,
  sijo: sijoShopConfig,
  simons: simonsShopConfig,
  skhoop: skhoopShopConfig,
  sozy: sozyShopConfig,
  spell: spellShopConfig,
  'spell-usa': spellusaShopConfig,
  standardandstrange: standardandstrangeShopConfig,
  statebags: statebagsShopConfig,
  statethelabel: statethelabelShopConfig,
  superx: superxShopConfig,
  surlacote: surlacoteShopConfig,
  southerntide: southerntideShopConfig,
  southerntaters: southernTatersShopConfig,
  swoveralls: swoverallsShopConfig,
  tallsize: tallsizeShopConfig,
  'tallsize-ca': tallsizeCaShopConfig,
  talulah: talulahShopConfig,
  tecovas: tecovasShopConfig,
  teddyblake: teddyblakeShopConfig,
  teekiboutique: teekiboutiqueShopConfig,
  tenable6: tenable6ShopConfig,
  tentree: tentreeShopConfig,
  'tentree-ca': tentreeCaShopConfig,
  'texas-standard': texasstandardShopConfig,
  tradlands: tradlandsShopConfig,
  treetfonts: treetfontsShopConfig,
  theandibrand: theandibrandShopConfig,
  thebeaufortbonnetcompany: thebeaufortbonnetcompanyShopConfig,
  thebeeandthefox: thebeeandthefoxShopConfig,
  theheygang: theheygangShopConfig,
  'thehippieshake-us': thehippieshakeUsShopConfig,
  'thehippieshake-uk': thehippieshakeUkShopConfig,
  thelullabyclub: thelullabyclubShopConfig,
  thenutr: thenutrShopConfig,
  thesak: thesakShopConfig,
  'theslowwardrobe-us': theslowwardrobeUsShopConfig,
  'theslowwardrobe-uk': theslowwardrobeUkShopConfig,
  tortugabackpacks: tortugabackpacksShopConfig,
  timininous: timininousShopConfig,
  treeton: treetonShopConfig,
  tripleaughtdesign: tripleaughtdesignShopConfig,
  tuesdayofcalifornia: tuesdayofcaliforniaShopConfig,
  ukje: ukjeShopConfig,
  unhide: unhideShopConfig,
  unif: unifShopConfig,
  unionbay: unionbayShopConfig,
  unitedbyblue: unitedbyblueShopConfig,
  urbancred: urbancredShopConfig,
  velvety: velvetyShopConfig,
  vetta: vettaShopConfig,
  viscata: viscataShopConfig,
  vitaeapparel: vitaeapparelShopConfig,
  vitalydesign: vitalydesignShopConfig,
  'vivobarefoot-ca': vivobarefootcaShopConfig,
  vpl: vplShopConfig,
  wayre: wayreShopConfig,
  weisswatchcompany: weisswatchcompanyShopConfig,
  westernandco: westernandcoShopConfig,
  whimsyandrow: whimsyandrowShopConfig,
  wildrye: wildryeShopConfig,
  wolven: wolvenShopConfig,
  woodleylowe: woodleyloweShopConfig,
  wornhub: wornhubShopConfig,
  whyandwhale: whyandwhaleShopConfig,
  wray: wrayShopConfig,
  youer: youerShopConfig,
  ziabird: ziabirdShopConfig,
  zulily: zulilyShopConfig,
  heathceramics: heathCeramicsShopConfig,
  tadashishoji: tadashishojiShopConfig,
  teacollection: teacollectionShopConfig,
  waterlust: waterlustShopConfig,
  andar: andarShopConfig,
  blackmilkclothing: blackmilkclothingShopConfig,
  'blackmilkclothing-us': blackmilkclothingUsShopConfig,
  blueillusion: blueillusionShopConfig,
};

// Create a ShopConfigV2 by combining the shop config from Contentful and the one in code
export const buildShopConfig = (contentfulShopConfig: ShopConfigResponse): ShopConfigV2 => {
  const { categoriesConfig, shopId } = contentfulShopConfig;
  const privateShopConfig = privateShopConfigs[shopId];

  const shouldUseShopStyleValues = isFeatureEnabled(Feature.ShopColors, shopId);

  let defaultShopStyles = fallbackDefaultStyles;

  if (shouldUseShopStyleValues) {
    try {
      defaultShopStyles = generateDefaultShopStyles(contentfulShopConfig?.css);
    } catch (e) {
      // Log error but don't throw, use fallback styles instead.
      log.error(e, 'set-shopcolor-style-failed', { treetId: shopId });
    }
  }

  const defaultShopStylesConfig = { defaultShopStyles };

  return {
    ...contentfulShopConfig,
    ...privateShopConfig,
    ...defaultShopStylesConfig,
    ...(categoriesConfig && {
      filters: [
        ...privateShopConfig.filters,
        getCategoryFilterConfig({
          id: categoriesConfig.filterId as FilterId | undefined,
          shouldUseTreetOptions: categoriesConfig.useTreetOptions,
          options: categoriesConfig.categoriesCollection?.items || [],
        }),
      ],
    }),
  };
};

export const getPrivateShopConfig = (treetId: string) => privateShopConfigs[treetId];

/**
 * Translates a V2 version of the shop config (from contentful) to a V1 version
 * This is used to bridge the gap between V1 & V2. Eventually, everything should
 * be accessed directly from V2.
 * @param {shopConfigV2} shopConfigV2
 * @returns V1 version of the shopconfig
 */
export const combineV1AndV2Config = (shopConfigV1: any, shopConfigV2: ShopConfigV2) => {
  // Remove fields that are undefined/null
  const cleanShopConfigV2 = omitBy(shopConfigV2, isNil);

  return {
    ...shopConfigV1,
    ...cleanShopConfigV2,
  };
};
